const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'

// Base path for the chat that owns the message. scope: 'searchroom' | 'global'.
function basePath(scope, chatId) {
  const root = scope === 'global' ? 'global-search-chats' : 'searchrooms'
  return `${BASE_URL}/${root}/${chatId}/messages`
}

// Fetch an assistant answer as a file (docx/pdf/txt) and trigger a browser
// download. Uses the auth cookie (credentials: 'include'), same as the rest of
// the API, and reads the server-provided filename from Content-Disposition.
export async function downloadAnswer({ scope, chatId, messageId, format }) {
  const url = `${basePath(scope, chatId)}/${messageId}/export?format=${encodeURIComponent(format)}`
  const res = await fetch(url, { credentials: 'include' })
  if (!res.ok) {
    let message = 'Export failed'
    try {
      const data = await res.json()
      message = data.error || message
    } catch {
      /* non-JSON error body */
    }
    throw new Error(message)
  }

  const blob = await res.blob()
  const disposition = res.headers.get('content-disposition') || ''
  const match = /filename="?([^"]+)"?/.exec(disposition)
  const filename = match ? match[1] : `codetalk-answer.${format}`

  const href = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = href
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(href)
}
